import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { MdCloudUpload,MdPhone,MdLocationPin } from 'react-icons/md'
import Loader from './Loader';
import {deleteObject, ref } from 'firebase/storage'
import { storage } from '../firebase.config';
import { getAllFoodItems, saveItem, saveUserDetail } from '../utils/firebaseFunctions';
import { useStateValue } from '../context/StateProvider';
import { actionType } from '../context/reducer';


const CreateContainer = () => {
  const [phone, setPhone] = useState("");
  const [loc, setLoc] = useState("");

  const [fields, setFields] = useState(false);
  const [alertStatus, setAlertStatus] = useState("danger")
  const[msg, setMsg] = useState(null)
  const[isLoading, setIsLoading] = useState(false)
  const[latitude,setLatitude] = useState('')
  const [{foodItems,user}, dispatch] = useStateValue();

  const uploadImage=()=>
  {
    navigator.geolocation.getCurrentPosition((position)=>{
      setIsLoading(true)
     
      let a = position.coords.latitude +','+position.coords.longitude
      setLatitude(a)
      setIsLoading(false)


    })

  }
  
  const clearData = ()=>
  {
    setPhone("")
    setPhone(null)

  }

  const saveDetail= ()=>
  {
    setIsLoading(true)
    try 
    {
      if(!phone  || !latitude)
      {
        setFields(true)
        setMsg("Required Field must be filled")
        setAlertStatus('danger')
        setTimeout(()=>{
          setFields(false)
          setIsLoading(false)
        },4000)
      }else{
        const data ={
          id: user.uid,
          phoneNo: phone,
          location: loc == '' ? latitude : loc,
          displayName: user.displayName,
          email: user.email,
          phoneNumber: user.phoneNumber,
          photoURL: user.photoURL,
          providerId: user.providerId,
          uid: user.uid

          
        }
        saveUserDetail(user.uid,data)
        // saveItem(data)
        localStorage.setItem('user',JSON.stringify(data))
        setIsLoading(false)
        setFields(true)
        setMsg('Data Uploaded successfully')
        clearData()
        setAlertStatus('success')
        setTimeout(()=>{
          setFields(false)
          setIsLoading(false)
          
        },4000)
        fetchData()
      }
      
    } catch (error) {
      console.log(error)
      setFields(true)
      setMsg("Error while uploading image")
      setAlertStatus('danger')
      setTimeout(()=>{
        setFields(false)
        setIsLoading(false)

      },4000)
      
    }

  }
  const fetchData = async () =>{
    await getAllFoodItems().then((data) =>{
      dispatch({
        type: actionType.SET_FOOD_ITEMS,
        foodItems: data
      })
    })
  }

  return (
    <div className="w-full min-h-screen flex items-center justify-center ">
      <div className="w-[90%] md:w-[75%] border border-gray-300 rounded-lg p-4 flex flex-col items-center justify-center gap-4">
        {
          fields && (
            <motion.p 
              initial={{opacity:0}}
              animate={{opacity:1}}
              exit={{opacity:0}}
              className={`w-full  p-2 rounded-lg text-center text-lg  ${alertStatus === "danger"? " bg-red-400 text-red-800":" bg-emerald-400 bg-emerald-800 text-white"}`}>
              {msg}
            </motion.p>
          )
        }
        <div className="w-full py-2 border-b border-gray-300 flex items-center gap-2">
          <MdPhone className='text-xl text-gray-700'/>
          <input type="text" name="" id="" value={phone} onChange={(e)=> setPhone(e.target.value)} placeholder="Enter a Phone Number"
          className='w-full h-full text-lg bg-transparent  outline-none border-none placeholder:text-gray-400 text-textColor' />

        </div>
        <div className="w-full py-2 border-b border-gray-300 flex items-center gap-2">
          <MdLocationPin className='text-xl text-gray-700'/>
          <input type="text" name="" id="" value={loc} onChange={(e)=> setLoc(e.target.value)} placeholder="Enter a Address Manually"
          className='w-full h-full text-lg bg-transparent  outline-none border-none placeholder:text-gray-400 text-textColor' />

        </div>
        
        <div className='group flex justify-center items-center flex-col border-2 border-dotted border-gray-300 w-full h-255 md:h-420 cursor-pointer rounded-lg'>
          {isLoading ? (<Loader />): (
          <>
          {latitude === ''   ? 
          (<>
            <label className="w-full h-full flex flex-col items-center justify-center cursor-pointer">
              <div className="w-full h-full flex flex-col items-center justify-center  gap-2">
                <MdCloudUpload className='text-gray-500  text-3xl hover:text-gray-700' />
                <p className="text-gray-500 hover:text-gray-700">Click Here to Get Live Location</p>

              </div>
              <input type="button" name="UploadImage" value='upload LONG'  className='w-0 h-0' onClick={uploadImage}  />
            </label>
          </>) :
         ( <>
            <div className="relative h-full">

              <iframe width="100%" src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCpnb3p_rdxfyGJbkmYt-Z1jGtI3PmmI3o&q=${latitude}`} className="w-full h-full object-cover"  ></iframe>
              
            </div>
          </>)}

          </>)}
        </div>
        {/* <div className="w-full flex flex-col md:flex-row items-center gap-3">
          <div className="w-full py-2 border-b border-gray-300 flex items-center gap-2">
            <MdFoodBank className="text-gray-700 text-2xl" />
            <input type="text" required placeholder='Calories' value={calories} onChange={(e)=> setCalories(e.target.value)} className='w-full h-full text-lg bg-transparent outline-none border-none placeholder:text-gray-400 text-textColor' />

          </div>
          <div className="w-full py-2 border-b border-gray-300 flex items-center gap-2">
            <MdAttachMoney className="text-gray-700 text-2xl" />
            <input type="text" required placeholder='Price' value={price} onChange={(e)=> setPrice(e.target.value)} className='w-full h-full text-lg bg-transparent outline-none border-none placeholder:text-gray-400 text-textColor' />

          </div>
        </div> */}
        <div className="flex items-center w-full">
          <button type='button' className="ml-0 md:ml-auto w-full md:w-auto border-none outline-none bg-emerald-500 px-12 py-2 rounded-lg text-lg text-white font-semibold" onClick={saveDetail}>
            Save

          </button>

        </div>
  

      </div>
    </div>
  )
}

export default CreateContainer